<div id="wrapper" class="app rtl">

    <main class="app-content">

    <div class="app-title">
      <div>
        <h1><i class="fa fa-user"></i> UMaT ADMISSIONS LOGIN GENERATOR (International Applicants Only)</h1>
        <p>Please fill the following below to generate a login</p>
      </div>
      <!-- <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item">Forms</li>
        <li class="breadcrumb-item"><a href="#">Sample Forms</a></li>
      </ul> -->
    </div>


    <div class="row">
     
        <div class="col-md-6">
            <div class="tile">
              <!-- <h3 class="tile-title">Card Title</h3> -->
              <div class="tile-body">
                
                <div class="row">
                    <div class="col-md-10">
                        <p>International applicants should follow the steps below: </p>
                        <ol id="id">
                          <li>Applicants  should fill in the <strong>International Applicants  Code Request Form</strong> below with a valid mobile number in the format given. Eg 00234812345678 becomes 234812345678.</li>
                          <li>You  will receive the <strong>Serial  Number</strong> and<strong> Personal Identification Number</strong> via <strong>Text Message </strong>and<strong> Email Address</strong> to access the <strong>Online Admission</strong> <strong> System</strong>.</li>
                          <li>Complete  the <strong>Online Application</strong> process with the Serial Number and Personal Identification Number sent to your Email or Mobile No.</li>
                          <li>Print  the completed form and add photocopies of relevant certificates</li>
                          <li>Scan and email all application documents to admissions.umat.edu.gh<br>
                        </li>
                      </ol>
                      <p id="warning">Please in case of any difficulty, or for further enquiries, call our direct line +233 3123 20323 between 8.00 am and 5.00 pm from Monday to Friday.</p>
                    </div>
                </div>

          

                
                    
                
              </div>
              <div class="tile-footer">
                <a class="btn btn-primary" href="javascipt::">Read More..</a>
                <a class="btn btn-success pull-right" 
                [routerLink]="[ '/account/login' ]">Login to Portal</a>
              
              </div>
            </div>
          </div>




      <div class="col-md-6">
        <div class="tile">
          <!-- <h3 class="tile-title">Register</h3> -->
          <div class="tile-body">
           
              <router-outlet></router-outlet>
          </div>
         
        </div>
      </div>
      <div class="clearix">
        
      </div>
 
    </div>

      </main>
</div>